import React, { useEffect, useState } from 'react'
 

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import {  showEmployeRequests, updateEmployeRequests } from '../../../../MyApi/hr/employerequests'


import PageHeader from '../../../../Components/UI/PageHeader'


import LoadingSpinner from '../../../../Components/UI/spinner'
import EditEmployeRequest from '../../../../Components/hr/employrequests/employrequestsUpdate/AddPayrolls'


const EmployeRequestsUpdate = () => {
const [sb_request_id ,setRequestId]= useState("")
const [sb_employe_id , setEmployId] =useState("")
const [date_from , setDateFrom] =useState("")
const [date_to ,setDateTo]= useState("")
const [time_from, setTimeFrom] = useState("")
const [time_to ,setTimeTo] = useState("")
const [image, setImage] = useState('');
const [amount ,setAmount] =useState("")
const [hours_count ,setHoursCount] =useState("")
const [days_count, setDaysCount] = useState("")
const [note ,setNote] = useState("")
const {id}=useParams()
const lang = localStorage.getItem("i18nextLng")
const [selectedCodeLang ,setSelectedCodeLang] = useState(lang)
const {data ,isLoading} =useQuery(["showemploymentrequests" ,id ,selectedCodeLang] ,()=> showEmployeRequests(id,selectedCodeLang ))
 const mutation = useMutation(["updateEmployRequests",id,selectedCodeLang] , (postData)=>updateEmployeRequests(postData,id ,selectedCodeLang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })
const employmentRequests = data?.data || []

useEffect(()=>{
   setRequestId(employmentRequests.sb_request_id)
   setEmployId(employmentRequests.sb_employe_id)
   setDateFrom(employmentRequests.date_from)
   setDateTo(employmentRequests.date_to)
   setTimeFrom(employmentRequests.time_from)
   setTimeTo(employmentRequests.time_to)
   setImage(employmentRequests.image)
   setAmount(employmentRequests.amount)
   setHoursCount(employmentRequests.hours_count)
   setHoursCount(employmentRequests.days_count)
   setNote(employmentRequests.note)
},[employmentRequests])

 const handlePostRequest =()=>{
    const formData = new FormData()
    formData.append("sb_request_id",sb_request_id)
    formData.append("sb_employe_id", sb_employe_id)
    formData.append("date_from", date_from)
    formData.append("date_to", date_to)
    formData.append("time_from", time_from)
    formData.append("time_to", time_to)
    formData.append("image", image)
    formData.append("amount", amount)
    formData.append("hours_count", hours_count)
    formData.append("days_count", days_count)
    formData.append("note", note)
    formData.append("lang_code", selectedCodeLang)
    mutation.mutate(formData)
 }
 const isDisabled= ()=>{
    return 
 }
 const onSelectChange=(e)=>{
   selectedCodeLang(e.target.value)
 }
 if(isLoading){
   return <LoadingSpinner/>
}
if(!data){
   return <div>no data avalible</div>
}
  return ( 

    <div>
        <PageHeader showSelect onSelectChange={onSelectChange} title="Edit Employe Request" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
       <EditEmployeRequest   setRequestId={setRequestId} setNote={setNote}  setEmployId={setEmployId} setHoursCount={setHoursCount}  setAmount={setAmount}  setDateFrom={setDateFrom} setDaysCount={setDaysCount} setTimeTo={setTimeTo} setDateTo={setDateTo} setTimeFrom={setTimeFrom} amount={amount} setImage={setImage} requestId={sb_request_id} employId={sb_employe_id}  date_from={date_from} date_to={date_to} time_to={time_to}    time_from={time_from} image={image} hours_count={hours_count} days_count={days_count} note={note} />
    </div>
  )
}

export default  EmployeRequestsUpdate ;
